import { render, staticRenderFns } from "./EmployedArchive.vue?vue&type=template&id=41a97f93&v-if=this.user.loggedIn"
import script from "./EmployedArchive.vue?vue&type=script&lang=js"
export * from "./EmployedArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports